import { render } from "./RequestRegular.view.vue?vue&type=template&id=07d5f44e"
import script from "./RequestRegular.view.vue?vue&type=script&lang=js"
export * from "./RequestRegular.view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__